import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-notification2-icon',
  templateUrl: './general-notification2.component.html'
})
export class GeneralNotification2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
